import { render, staticRenderFns } from "./BuyCover.vue?vue&type=template&id=39cdf5f8&scoped=true"
import script from "./BuyCover.vue?vue&type=script&lang=js"
export * from "./BuyCover.vue?vue&type=script&lang=js"
import style0 from "./BuyCover.vue?vue&type=style&index=0&id=39cdf5f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cdf5f8",
  null
  
)

export default component.exports